export function HeartIcon({ className, isFavorite }: { className?: string; isFavorite?: boolean }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      className={`group ${className}`}
    >
      {!isFavorite ? (
        <path
          d="M10.9999 1.88281C9.83992 1.88281 8.72658 2.42281 7.99992 3.27615C7.27325 2.42281 6.15992 1.88281 4.99992 1.88281C2.94659 1.88281 1.33325 3.49615 1.33325 5.54948C1.33325 8.06948 3.59992 10.1228 7.03325 13.2428L7.99992 14.1161L8.96658 13.2361C12.3999 10.1228 14.6666 8.06948 14.6666 5.54948C14.6666 3.49615 13.0533 1.88281 10.9999 1.88281ZM8.06659 12.2495L7.99992 12.3161L7.93325 12.2495C4.75992 9.37615 2.66659 7.47615 2.66659 5.54948C2.66659 4.21615 3.66659 3.21615 4.99992 3.21615C6.02659 3.21615 7.02658 3.87615 7.37992 4.78948H8.62658C8.97325 3.87615 9.97325 3.21615 10.9999 3.21615C12.3333 3.21615 13.3333 4.21615 13.3333 5.54948C13.3333 7.47615 11.2399 9.37615 8.06659 12.2495Z"
          fill="currentColor"
        />
      ) : null}
      {isFavorite ? (
        <>
          <path
            d="M7.99992 14.1161L7.03325 13.2361C3.59992 10.1228 1.33325 8.06948 1.33325 5.54948C1.33325 3.49615 2.94659 1.88281 4.99992 1.88281C6.15992 1.88281 7.27325 2.42281 7.99992 3.27615C8.72658 2.42281 9.83992 1.88281 10.9999 1.88281C13.0533 1.88281 14.6666 3.49615 14.6666 5.54948C14.6666 8.06948 12.3999 10.1228 8.96658 13.2428L7.99992 14.1161Z"
            fill="currentColor"
            className="group-hover:hidden"
          />
          <path
            d="M13.0468 2.86769C11.7668 2.00769 10.3268 2.08769 9.18018 2.69436L8.00018 6.23436H9.10684C9.55351 6.23436 9.87351 6.66769 9.74684 7.09436L8.53351 11.141C8.47351 11.3344 8.18684 11.2744 8.20684 11.0744L8.66684 6.90103H7.55351C7.11351 6.90103 6.79351 6.47436 6.91351 6.05436L7.70018 3.31436C6.46684 2.16103 4.47351 1.78103 2.84684 2.92769C1.88018 3.61436 1.33351 4.70103 1.33351 5.89436C1.32684 8.43436 3.68684 10.3677 7.10684 13.4277C7.61351 13.881 8.38684 13.8877 8.90018 13.4344C12.2202 10.4877 14.8135 8.38103 14.6602 5.68769C14.6002 4.53436 14.0002 3.51436 13.0468 2.86769Z"
            fill="currentColor"
          />
        </>
      ) : null}
    </svg>
  )
}
